import styled from "styled-components";

export const FeaturesContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 11rem;

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: flex-start;
  }
  @media (max-width: 600px) {
    margin-top: 14rem;
  }
  @media (max-width: 480px) {
    margin-top: 7.6rem;
  }
`;

export const FeaturesCardContainer = styled.div`
  width: 67%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  @media (max-width: 1024px) {
    width: 100%;
  }
  @media (max-width: 600px) {
    width: 100%;
  }
`;
export const TitleContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  @media (max-width:1024px) {
    width:100%;
  }
  span {
    display: inline-block;
    width: 11.11px;
    height: 21px;
    position: absolute;
    top: 52px;
    left: 98%;
    background-color: ${(props) => props.color || "#fff"};
  }
  h5 {
    font-size: 1.6rem;
    font-weight: 800;
    color: ${(props) => props.titleColor || "#FFFFFF"};
    opacity: ${(props) => props.opacity || "1"};
    margin-bottom: 0.6rem;
    font-family: Peyda;
  }
  /* p {
    font-size: 3.2rem;
    font-weight: 70rem;
    line-height: 5.3rem;
    padding-right: 1.4rem;
    color: ${(props) => props.textColor || "#FFFFFF"};
  } */
 

`;
export const TextContainer = styled.div`
  width: ${(props) => props.width};
  height: 168px;
  margin-top: 0.8rem;

  p {
    font-weight: 700;
    font-family: Peyda;
    font-size: 3.2rem;
    line-height: 5.6rem;
    padding-right: 1.4rem;
    color: var(--text-color);
  }
  @media (max-width: 600px) {
    height: auto;
    margin-bottom: 40px;
  }
  @media (max-width: 1024px) {
    width: ${(props) => props.width1024 || "100%"};
    height: ${(props) => props.height};
    p {
      font-size: 2.6rem;
      margin-right: 5px;
    }
  }
  @media (max-width: 600px) {
    width: ${(props) => props.width600 || "465px"};
    height: ${(props) => props.height || "100px"};
    p {
      font-size: 2.2rem;
    }
  }
  @media (max-width: 580px) {
    width: ${(props) => props.width600 || "100%"};
  }
`;
